import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsCultures(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS,
		ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_CULTURES,
		options
	)
}

function _getReportsFields(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS,
		ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_FIELDS,
		options
	)
}

function _getReportsMaterialsVolumes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS,
		ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_MATERIALS_VOLUMES,
		options
	)
}

function _getReportsProductVolumes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS,
		ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_PRODUCT_VOLUMES,
		options
	)
}

function _getReportsRelatedObjects(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS,
		ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_RELATED_OBJECTS,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_CULTURES]: _getReportsCultures,
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_FIELDS]: _getReportsFields,
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_MATERIALS_VOLUMES]: _getReportsMaterialsVolumes,
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_PRODUCT_VOLUMES]: _getReportsProductVolumes,
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_RELATED_OBJECTS]: _getReportsRelatedObjects,
}
